// @flow strict

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './mobileMenuItem.module.less';

export const MobileMenuItem = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleList = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div className={styles.menuItem} onClick={toggleList}>
        <span className={styles.menuItemLabel}>
          {data.href ? <a href={data.href}>{data.name}</a> : data.name}
        </span>
        {data.items && (
          <div
            className={
              isOpen
                ? styles.menuItemToggle + ' ' + styles.menuItemToggleRotate
                : styles.menuItemToggle
            }
          />
        )}
      </div>
      {isOpen && data.items && (
        <ul className={styles.subMenuItemsList}>
          {data.items.map((item) => {
            const isIndustries = data.name === 'Industries' || data.name === 'Branchen';
            const iconClass = isIndustries ? styles.industryIcon : styles.productIcon;

            return (
              <li key={item.name}>
                <a className={styles.subItem} href={item.href}>
                  {item.image && (
                    <img
                      className={iconClass}
                      src={item.image.src.publicURL}
                      alt={item.image.src.alt}
                    />
                  )}
                  <span>{item.name}</span>
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

MobileMenuItem.propTypes = {
  data: PropTypes.object,
};
